import { ReactNode } from 'react';
import { useAppSelector } from 'store/hooks';
import { hasAnyPermission } from 'utils/permissions';
import { selectPermissionCodes } from 'store/features/permissions/selector';

type PermissionHandlerProps = {
  requiredPermissionCodes: readonly string[];
  children: ReactNode;
};

const PermissionHandler = ({ requiredPermissionCodes, children }: PermissionHandlerProps) => {
  const permissionCodes = useAppSelector(selectPermissionCodes);

  const isShow = hasAnyPermission(permissionCodes, requiredPermissionCodes);

  return isShow ? <>{children}</> : null;
};

export default PermissionHandler;
